/* eslint-disable jsx-a11y/anchor-is-valid */
import { type FC } from "react";
import { Toast } from "flowbite-react";

export interface SnackbarProps {
  model: boolean;
  content?: React.ReactNode;
  icon?: React.ReactNode;
  close: () => void;
}

export const Snackbar: FC<SnackbarProps> = (props) => {
  return (
    <div>
      {props.model && (
        <Toast className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-10 text-white bg-gray-800 dark:text-white">
          {props.icon && (
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primaryBlue">
              {props.icon}
            </div>
          )}
          <div className="ml-3 text-sm font-normal">{props.content}</div>
          <Toast.Toggle
            onClick={() => props.close()}
            className="text-white bg-gray-800 dark:text-muted hover:bg-gray-600 hover:text-white dark:text-white"
          />
        </Toast>
      )}
    </div>
  );
};
